import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  ButtonCreateEvent,
  ButtonLink,
  ContentCreateEvent,
  ContentSelect,
  List,
  ShowImageContainer,
  TextTitleList,
  UploadImageContainer,
  SelectStyles,
  ContentPortal,
  HeaderContent,
  InfoContent,
  ButtonCancel,
  useStyles,
} from "./ManageEvent.styled";
import { Col, Form, Row } from "react-bootstrap";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  Radio,
  Tooltip,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import { useHistory, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { useMutation } from "@apollo/client";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { NotificationManager } from "react-notifications";
import {
  ADD_NEW_EVENT,
  UPDATE_EVENT,
} from "../../GraphQL/Mutations";
import PortalModal from "../../Portals/PortalModal.jsx";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import SpeedIcon from "@material-ui/icons/Speed";
import moment from "moment";
import UploadImage from "../UploadImage/UploadImage";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import { uploadFile, getFile } from "../../services/FileManager";
import CreateSpeakerContainer from "../../containers/CreateSpeakerContainer/CreateSpeakerContainer";
import EditorConvertToMarkdown from "../EditorConvertToMarkdown/EditorConvertToMarkdown";
import { clientWellness } from "../../App";
import RecurrenceComponent from "../RecurrenceComponent/RecurrenceComponent";
import ModalAdvanceOptions from "../ModalAdvanceOptions/ModalAdvanceOptions";
import ModalRecurrence from "../ModalRecurrence/ModalRecurrence";
import ListOfRecurring from "../ListOfRecurring/ListOfRecurring";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import { RRule } from "rrule";
import ModalLoader from "../ModalLoader/ModalLoader";
import BackButtonComponent from "../BackButtonComponent/BackButtonComponent";
import PropTypes from "prop-types";

const ManageEvent = ({
  action,
  idEvent,
  usersAdvanceSearch,
  detailEvent,
  categories,
  countries,
  cities,
  setCities,
  languages,
  speakers,
  guestsData,
  individualGuests,
  allCountries,
  allCities,
  setAllCities,
  allLobs,
  allRolesByLevel,
  selectedCountry,
  selectedCity,
  selectedRole,
  selectedLob,
  showCreateSpeaker,
  showAdvanceOption,
  loadingEventById,
  errorEventById,
  loadingRoleByLevel,
  errorRoleByLevel,
  loadingUsersInRole,
  errorUsersInRole,
  setIndividualGuests,
  setShowCreateSpeaker,
  setSelectedCountry,
  setSelectedCity,
  handleCleanSelects,
  handleGoToBackPage,
  handleCities,
  handleCitiesByCountry,
  handleUsersByIds,
  handleChangeSelectRole,
  handleChangeSelectLob,
  handleValideKey,
  handleCloseAdvanceSearch,
  handleCleanEventRecurring,
  setShowUpdateRecurringButton,
  setShowEventRecurring,
  showEventRecurring,
  handleCloseEventRecurring,
  repeatEvery,
  setRepeatEvery,
  dateOptions,
  periodRecurring,
  setPeriodRecurring,
  dataButtonDays,
  dataButtonDaysValue,
  optionForMonth,
  optionForMonthSelected,
  setOptionForMonthSelected,
  dataEndsDate,
  activeEndsRecurring,
  setActiveEndsRecurring,
  onEndRecurring,
  setOnEndRecurring,
  showUpdateRecurringButton,
  handleCreateRecurringEvent,
  handleUpdateRecurringEvent,
  recurringEvents,
  setRecurringEvents,
  handleEditRecurring,
  openDeleteRecurringModal,
  setOpenDeleteRecurringModal,
  handleDeleteRecurring,
  recurrence,
  handleChangeComoNoComo,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const rComoNonComo = useRef();
  const rCountries = useRef();
  const rCities = useRef();
  const rRoles = useRef();
  const rLobs = useRef();
  const rSelectedUsers = useRef();
  const rEventType = useRef();
  const rCategoryObj = useRef();
  const rCountryObj = useRef();
  const rCityObj = useRef();
  const rLanguageObj = useRef();

  const eventId = useMemo(() => idEvent, []);
  const [cityId, setCityId] = useState(null);
  const [countryId, setCountryId] = useState(null);
  const [eventCategoryId, setEventCategoryId] = useState(null);
  const [eventDescription, setEventDescription] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventType, setEventType] = useState("");
  const [eventUri, setEventUri] = useState("");
  const [finishDate, setFinishDate] = useState();
  const [privateGroups, setPrivateGroups] = useState([]);
  const [publicGroups, setPublicGroups] = useState([]);
  const [languageId, setLanguageId] = useState();
  const [participantsLimit, setParticipantsLimit] = useState();
  const [photoFile, setPhotoFile] = useState();
  const [previewImage, setPreviewImage] = useState();
  const [nameImage, setNameImage] = useState();
  const [speakersSelected, setSpeakersSelected] = useState([]);
  const [startDate, setStartDate] = useState();
  const eventStatus = useMemo(() => "ACTIVE", []);

  const [renderAgain, setRenderAgain] = useState(false);
  const selectedUsers = useMemo(() => [], []);

  const [activePublic, setActivePublic] = useState(false);
  const [activePrivate, setActivePrivate] = useState(false);

  const folderName = useMemo(() => "Events", []);
  const [fileName, setFileName] = useState();
  const [finalIndividualGuests, setFinalIndividualGuests] = useState();
  const [finalSpeakerSelection, setFinalSpeakerSelection] = useState();
  const [showLoader, setShowLoader] = useState(false);

  const [addNewEvent] = useMutation(ADD_NEW_EVENT, {
    client: clientWellness,
  });
  const [updateEvent] = useMutation(UPDATE_EVENT, {
    client: clientWellness,
  });

  useEffect(() => {
    if (selectedUsers.length > 0) {
      let selected = selectedUsers.map((element) => {
        return element.value;
      });
      handleUsersByIds([...selected]);
    } else {
      setIndividualGuests([]);
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (individualGuests.length) {
      let selection = selectedUsers;
      individualGuests.map((element) => {
        if (selection.findIndex((f) => f.label === element.label) === -1) {
          selection.push(element);
        }
      });

      setIndividualGuests(selection);
    } else {
      setIndividualGuests(selectedUsers);
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (renderAgain) {
      setIndividualGuests(individualGuests);
      setRenderAgain(!renderAgain);
    }
  }, [individualGuests, renderAgain]);

  useEffect(() => {
    if (
      (fileName && action === "edit") ||
      (fileName === "" && action === "edit")
    ) {
      handleUploadEvent();
    }

    if (
      (fileName && action === "add") ||
      (fileName === "" && action === "add")
    ) {
      handleCreateEvent();
    }
  }, [fileName]);

  useEffect(() => {
    if (detailEvent && cities && action === "edit") {
      setCityId(detailEvent?.idCity);
      rCityObj.current.state.ariaSelection = {
        value: detailEvent?.cityId,
        label: detailEvent?.cityName,
      };
      rCityObj.current.state.selectValue = [
        {
          value: detailEvent?.cityId,
          label: detailEvent?.cityName,
        },
      ];
    }
  }, [detailEvent, cities]);

  useEffect(() => {
    if (
      detailEvent?.eventName &&
      action === "edit" &&
      !loadingEventById &&
      !errorEventById
    ) {
      let individualGuestsSelection =
        detailEvent?.wellnessSearchGroupUsers?.map((element) => {
          return {
            value: element?.user?.userId,
            label: element?.user?.firstName + " " + element?.user?.lastName,
          };
        });
      let speakerSelection = detailEvent?.wellnessSpeakerEvents?.map(
        (element) => {
          return element.idSpeakerNavigation;
        }
      );
      setEventName(detailEvent?.eventName);
      setEventDescription(detailEvent?.description);
      setEventCategoryId(detailEvent?.idCategory);
      rCategoryObj.current.state.ariaSelection =
        detailEvent?.idCategoryNavigation;
      rCategoryObj.current.state.selectValue = [
        detailEvent?.idCategoryNavigation,
      ];
      setCountryId(detailEvent?.idCountry);
      rCountryObj.current.state.ariaSelection = {
        value: detailEvent?.countryId,
        label: detailEvent?.countryName,
      };
      rCountryObj.current.state.selectValue = [
        {
          value: detailEvent?.countryId,
          label: detailEvent?.countryName,
        },
      ];
      if (detailEvent?.idCountry) {
        handleCitiesByCountry(detailEvent?.idCountry);
      }
      setCityId(detailEvent?.idCity);
      rCityObj.current.state.ariaSelection = {
        value: detailEvent?.cityId,
        label: detailEvent?.cityName,
      };
      rCityObj.current.state.selectValue = [
        {
          value: detailEvent?.cityId,
          label: detailEvent?.cityName,
        },
      ];
      setLanguageId(detailEvent?.idLanguage);
      rLanguageObj.current.state.ariaSelection =
        detailEvent?.idLanguageNavigation;
      rLanguageObj.current.state.selectValue = [
        detailEvent?.idLanguageNavigation,
      ];
      setEventUri(detailEvent?.urlEvent);
      setSpeakersSelected(speakerSelection);
      setEventType(detailEvent?.eventType === "Private" ? "PRIVATE" : "PUBLIC");
      rEventType.current.value =
        detailEvent?.eventType === "Private" ? "PRIVATE" : "PUBLIC";
      getFile(detailEvent?.urlPhoto).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          response.lastModifiedDate = new Date();
          response.name = detailEvent?.urlPhoto;
          const myFile = new File([response], detailEvent?.urlPhoto, {
            type: response.type,
          });
          setPhotoFile({ file: myFile });
          setPreviewImage(URL.createObjectURL(response));
        }
      });
      setNameImage(detailEvent?.urlPhoto);
      setIndividualGuests(individualGuestsSelection);
      setPublicGroups(detailEvent?.wellnessEventsCriteria);
      setPrivateGroups(detailEvent?.wellnessSearchGroups);
      setStartDate(new Date(detailEvent?.startDate));
      setFinishDate(new Date(detailEvent?.finishDate));
      setActivePublic(detailEvent?.eventType === "Public");
      setActivePrivate(detailEvent?.eventType === "Private");
      setParticipantsLimit(detailEvent?.participantsLimit);
      if (detailEvent?.recurrencePattern) {
        let rule = RRule.fromString(detailEvent?.recurrencePattern);
        setRecurringEvents([{ label: rule.toText(), eventId: eventId }]);
      }
    }
  }, [detailEvent, errorEventById, loadingEventById, eventId]);

  let createGroup = () => {
    let countrySelected = selectedCountry
      ? selectedCountry?.country.label + " "
      : "";
    let citySelected =
      (selectedCity?.cities ?? [])
        .map((item) => item.label)
        .toString()
        .replaceAll(",", " ") + " ";
    let roleSelected =
      (selectedRole?.roles ?? [])
        .map((item) => item.label)
        .toString()
        .replaceAll(",", " ") + " ";
    let lobSelected =
      (selectedLob?.lobs ?? [])
        .map((item) => item.label)
        .toString()
        .replaceAll(",", " ") + " ";
    let groupName = `${countrySelected + citySelected + roleSelected + lobSelected
      }`;

    if (groupName !== "" && activePrivate) {
      let newGroup = {
        groupName: groupName,
        userIds: usersAdvanceSearch.map((item) => item.userId),
        totalUsers: usersAdvanceSearch.length,
      }
      setPrivateGroups((prevGroups) => [...prevGroups, newGroup]);
      handleCloseAdvanceSearch();
    } else if (groupName !== "" && activePublic) {
      let newGroup = {
        groupName: groupName,
        criteria: {
          idCountry: selectedCountry?.country.value,
          cities:
            (selectedCity?.cities ?? []).length > 0
              ? (selectedCity?.cities ?? []).map((item) => item.value)
              : null,
          roles:
            (selectedRole?.roles ?? []).length > 0
              ? (selectedRole?.roles ?? []).map((item) => item.value)
              : null,
          lobs:
            (selectedLob?.lobs ?? []).length > 0
              ? (selectedLob?.lobs ?? []).map((item) => item.value)
              : null,
        },
        totalUsers: usersAdvanceSearch.length,
      }
      setPublicGroups((prevGroups) => [...prevGroups, newGroup]);
      handleCloseAdvanceSearch();
    }
  };

  let handleChangePublic = () => {
    setActivePublic(true);
    setActivePrivate(false);
    setEventType("PUBLIC");
  };

  let handleChangePrivate = () => {
    setActivePublic(false);
    setActivePrivate(true);
    setEventType("PRIVATE");
  };

  let handleUploadEvent = () => {
    let filterPrivateGroups = privateGroups.map((data) =>
      data.label ? { groupName: data.label } : data
    );
    let filterPublicGroups = publicGroups.map((data) =>
      data.label ? { groupName: data.label } : data
    );
    let groups =
      eventType === "PRIVATE" ? filterPrivateGroups : filterPublicGroups;

    let recurrenceObj = {
      lastOcurrence: recurrence.lastOcurrence,
      recurrencePattern: String(recurrence.recurrencePattern).replace("RRULE:", ""),
    }
    updateEvent({
      variables: {
        eventId,
        cityId,
        countryId,
        eventCategoryId,
        eventDescription,
        eventName,
        eventType,
        eventUri,
        finishDate,
        groups: groups,
        individualGuests:
          finalIndividualGuests?.length >= 1
            ? finalIndividualGuests
            : individualGuests,
        languageId,
        participantIsRequired: true,
        participantsLimit,
        photoUri: fileName || "",
        speakers:
          finalSpeakerSelection?.length > 0
            ? finalSpeakerSelection
            : speakersSelected,
        startDate,
        recurrence: recurrenceObj,
      },
    })
      .then((response) => {
        setShowLoader(false);
        if (response.errors) {
          NotificationManager.warning(response.errors[0].message, "", 5000);
        } else {
          NotificationManager.success("Event updated", "", 5000);
          history.push({
            pathname: `/Gamification`,
          });
          setTimeout(() => {
            history.push({
              pathname: location.state.path,
            });
          }, 0);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleCreateEvent = () => {
    let recurrenceObj = {
      lastOcurrence: recurrence.lastOcurrence,
      recurrencePattern: String(recurrence.recurrencePattern).replace("RRULE:", ""),
    }
    addNewEvent({
      variables: {
        cityId: cityId,
        countryId: countryId,
        eventCategoryId: eventCategoryId,
        eventDescription: eventDescription,
        eventName: eventName,
        eventStatus: eventStatus,
        eventType: eventType,
        eventUri: eventUri,
        finishDate: finishDate,
        groups: eventType === "PRIVATE" ? privateGroups : publicGroups,
        individualGuests: finalIndividualGuests,
        languageId: languageId,
        participantIsRequired: true,
        participantsLimit: participantsLimit,
        photoUri: fileName ? fileName : "",
        speakers: finalSpeakerSelection,
        startDate: startDate,
        recurrence: recurrenceObj,
      },
    })
      .then((response) => {
        setShowLoader(false);
        if (response.errors) {
          NotificationManager.error(response.errors[0].message, "", 5000);
        } else {
          NotificationManager.success("Event created", "", 5000);
          history.push({
            pathname: `/Gamification`,
          });
          setTimeout(() => {
            history.push({
              pathname: location.state.path,
            });
          }, 0);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let addEvent = () => {
    if (
      cityId &&
      countryId &&
      eventCategoryId &&
      eventDescription &&
      eventName &&
      eventStatus &&
      eventType &&
      languageId &&
      startDate &&
      finishDate &&
      individualGuests &&
      privateGroups
    ) {
      setShowLoader(true);
      setFinalIndividualGuests(
        individualGuests.map((element) => {
          return element.value;
        })
      );
      setFinalSpeakerSelection(speakersSelected.map((item) => item.value));

      if (
        new Date(startDate) < new Date(finishDate) &&
        new Date(startDate) >= new Date() &&
        new Date(finishDate) > new Date(startDate)
      ) {
        if (photoFile) {
          if (photoFile[0]) {
            uploadFile([photoFile[0]], folderName)
              .then((imageName) => {
                let arrayNames = JSON.parse(imageName);
                setFileName(arrayNames[0].newName);
              })
              .catch((error) => {
                setShowLoader(false);
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          }
        } else {
          setFileName("");
        }
      } else {
        setShowLoader(false);
        NotificationManager.warning(
          "Please select future time to create new event",
          "",
          5000
        );
      }
    } else {
      NotificationManager.warning("Missing fields", "", 5000);
    }
  };

  let editEvent = () => {
    if (
      cityId &&
      countryId &&
      eventCategoryId &&
      eventDescription &&
      eventName &&
      eventStatus &&
      eventType &&
      languageId &&
      startDate &&
      finishDate &&
      individualGuests &&
      privateGroups
    ) {
      setShowLoader(true);
      setFinalIndividualGuests(
        individualGuests.map((item) => {
          return item.value;
        })
      );
      setFinalSpeakerSelection(speakersSelected.map((item) => item.value));
      if (new Date(startDate) < new Date(finishDate)) {
        if (photoFile) {
          if (photoFile[0]) {
            uploadFile([photoFile[0]], folderName)
              .then((imageName) => {
                let arrayNames = JSON.parse(imageName);
                setFileName(arrayNames[0].newName);
              })
              .catch((error) => {
                setShowLoader(false);
                const errorMessage = error.message.split("\n")[0];
                NotificationManager.error(errorMessage, "", 5000);
              });
          } else if (photoFile?.file) {
            if (photoFile.file.name.indexOf("/") !== -1) {
              setFileName(photoFile.file.name);
            }
          }
        } else {
          setFileName("");
        }
      } else {
        setShowLoader(false);
        NotificationManager.warning(
          "Please select future time to create new event",
          "",
          5000
        );
      }
    } else {
      NotificationManager.warning("Missing fields", "", 5000);
    }
  };

  let handleChangeSelectCategories = (item) => {
    setEventCategoryId(item.value);
  };
  let handleChangeSelectCountries = (item) => {
    setCountryId(item.value);
    setCities([]);
    handleCitiesByCountry(item.value);
  };

  let handleChangeSelectCities = (item) => {
    setCityId(item.value);
  };
  let handleChangeSelectLanguages = (item) => {
    setLanguageId(item.value);
  };
  let handleChangeSelectSpeakers = (item) => {
    setSpeakersSelected(item);
  };
  let handleChangeSelectLimitPeople = (item) => {
    setParticipantsLimit(parseInt(item.target.value));
  };

  let handleChangeEventName = (item) => {
    setEventName(item.target.value);
  };

  let handleChangeEventUri = (item) => {
    setEventUri(item.target.value);
  };

  let handleImgUploadEvent = (type, item, urlPreviewImage) => {
    setPreviewImage(urlPreviewImage);
    setNameImage(item ? item[0].name : "");
    setPhotoFile(item);
  };

  let removeSpeaker = (index, item) => {
    let dto = speakersSelected;
    dto.splice(index, 1);
    setSpeakersSelected([...dto]);
    setRenderAgain(!renderAgain);
  };

  let removeGroupsAsigned = (index, item) => {
    if (activePrivate) {
      setPrivateGroups(prevPrivateGroups => {
        const newPrivateGroups = [...prevPrivateGroups];
        newPrivateGroups.splice(index, 1);
        return newPrivateGroups;
      });
      setRenderAgain(prevRenderAgain => !prevRenderAgain);
    } else if (activePublic) {
      setPublicGroups(prevPublicGroups => {
        const newPublicGroups = [...prevPublicGroups];
        newPublicGroups.splice(index, 1);
        return newPublicGroups;
      });
      setRenderAgain(prevRenderAgain => !prevRenderAgain);
    }
  };

  let handleChangeSelectCountry = (item) => {
    setSelectedCountry({
      country: item,
      countryIds: item.value,
    });
    if (item.value) {
      handleCities(item.value);
    } else {
      setAllCities([]);
    }
    rCities.current.state.ariaSelection = [];
    rCities.current.clearValue();
    setSelectedCity();
  };

  let handleChangeSelectCity = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedCity({
      cities: items,
      cityIds: selectedItems,
    });
  };

  let handleChangeSelectUsers = (items) => {
    if (items.length > 0) {
      let selection = individualGuests;
      items.map((element) => {
        if (selection.findIndex((f) => f.value === element.value) === -1) {
          selection.push(element);
        }
      });

      setIndividualGuests(selection);
      setRenderAgain(!renderAgain);
    } else {
      setIndividualGuests([]);
    }
  };

  let removeUserAsigned = (index, label) => {
    if (individualGuests.length < 2) {
      NotificationManager.warning(
        "There should be atleast one assigned user for private event.",
        "",
        5000
      );
      return;
    }
    if (rSelectedUsers.current.state.selectValue) {
      let objremove = rSelectedUsers.current.state.selectValue?.filter(
        (f) => f.value === individualGuests[index].value
      );
      if (objremove.length) {
        rSelectedUsers.current?.removeValue?.(objremove[0]);
      }
    }
    let dto = individualGuests;
    dto.splice(index, 1);
    setIndividualGuests([...dto]);
    setRenderAgain(!renderAgain);
  };

  const showDeleteRecurringModal = () => {
    return (
      openDeleteRecurringModal && (
        <ModalConfirmAction
          title={"Are you sure to delete the recurrence for this event?"}
          open={openDeleteRecurringModal}
          setOpen={setOpenDeleteRecurringModal}
          fn={handleDeleteRecurring}
        />
      )
    );
  };

  const modalAdvanceOptions = showAdvanceOption && (
    <ModalAdvanceOptions
      selectedUsers={selectedUsers}
      closeAdvanceSearch={handleCloseAdvanceSearch}
      allCountries={allCountries}
      handleChangeSelectCountry={handleChangeSelectCountry}
      rCountries={rCountries}
      rCities={rCities}
      rRoles={rRoles}
      rLobs={rLobs}
      allCities={allCities}
      handleChangeSelectCity={handleChangeSelectCity}
      loadingRoleByLevel={loadingRoleByLevel}
      errorRoleByLevel={errorRoleByLevel}
      allRolesByLevel={allRolesByLevel}
      handleChangeSelectRole={handleChangeSelectRole}
      allLobs={allLobs}
      handleChangeSelectLob={handleChangeSelectLob}
      usersAdvanceSearch={usersAdvanceSearch}
      createGroup={createGroup}
      rComoNonComo={rComoNonComo}
      handleChangeComoNoComo={handleChangeComoNoComo}
    />
  );

  const modalEventRecurring = showEventRecurring && (
    <ModalRecurrence
      isEvent={true}
      closeRecurring={handleCloseEventRecurring}
      repeatEvery={repeatEvery}
      setRepeatEvery={setRepeatEvery}
      dateOptions={dateOptions}
      periodRecurring={periodRecurring}
      setPeriodRecurring={setPeriodRecurring}
      dataButtonDays={dataButtonDays}
      dataButtonDaysValue={dataButtonDaysValue}
      optionForMonth={optionForMonth}
      optionForMonthSelected={optionForMonthSelected}
      setOptionForMonthSelected={setOptionForMonthSelected}
      dataEndsDate={dataEndsDate}
      activeEndsRecurring={activeEndsRecurring}
      setActiveEndsRecurring={setActiveEndsRecurring}
      onEndRecurring={onEndRecurring}
      setOnEndRecurring={setOnEndRecurring}
      showUpdateRecurringButton={showUpdateRecurringButton}
      createRecurring={handleCreateRecurringEvent}
      updateRecurring={handleUpdateRecurringEvent}
    />
  );

  const listOfSurveyRecurring = recurringEvents.length > 0 && (
    <ListOfRecurring
      list={recurringEvents}
      editRecurring={handleEditRecurring}
      setOpenDeleteRecurringModal={setOpenDeleteRecurringModal}
    />
  );

  const handleBackTitle = (title) => {
    if (title) {
      let words = title.replace("/", "").split(/(?=[A-Z])/);
      return words.join(' ');
    }
  }

  return (
    <ContentCreateEvent>
      <BackButtonComponent
        backtitle={`${handleBackTitle(location.state.path)}`}
        locationtitle={action === "add" ? "New Event" : "Edit Event"}
        goToBackPage={handleGoToBackPage}
      />
      {showLoader && <ModalLoader></ModalLoader>}
      {loadingEventById && !errorEventById && (
        <Row>
          <Col
            md="12"
            className="d-flex justify-content-center align-content-center my-5"
          >
            <PointersLine color={themeConfig.primary.purpleFadeDark} />
          </Col>
        </Row>
      )}
      {!loadingEventById && errorEventById && (
        <Row>
          <Col
            md="12"
            className="d-flex justify-content-center align-content-center my-5"
          >
            <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
          </Col>
        </Row>
      )}
      {!loadingEventById && !errorEventById && (
        <Row className={classes.contentFormForEvent}>
          <h2 className="section-title">General Information </h2>
          <Col md={6}>
            <Row>
              <Col md={12} className={"mt-3 mb-3"}>
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-name"
                  style={{ fontSize: "18px", color: themeConfig.neutral.black }}
                >
                  Name <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </InputLabel>
                <Form.Control
                  required
                  className={"w-98"}
                  id="outlined-name"
                  pattern={/[¡!¿?=\-+*()\/\[\]&%|$#."_@]/i}
                  placeholder={"Name of the event"}
                  defaultValue={`${eventName}`}
                  onChange={handleChangeEventName}
                />
              </Col>
              <Col md={12} className={"my-3"}>
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-description"
                  style={{ fontSize: "18px", color: themeConfig.neutral.black }}
                >
                  Description <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </InputLabel>
                <EditorConvertToMarkdown
                  editor={eventDescription}
                  setEditor={setEventDescription}
                  style={{ width: "98%" }}
                />
              </Col>
              <Col md={12} className={"my-3"}>
                <Form.Label className={""}>Event cover</Form.Label>
                <UploadImageContainer>
                  <div id="contaierUpLoadImagenBlock">
                    <UploadImage
                      displayNameButton="Add Image"
                      setFile={handleImgUploadEvent}
                      nameFile={nameImage}
                      withStyle={false}
                    ></UploadImage>
                  </div>
                  {previewImage && previewImage !== "#" ? (
                    <ShowImageContainer src={previewImage}></ShowImageContainer>
                  ) : null}
                </UploadImageContainer>
              </Col>
              <Col md={12} className={"mt-5 mb-3"}>
                <FormControl className={"w-98"}>
                  <Form.Label>
                    Event type <span style={{ color: themeConfig.primary.redLight }}>*</span>
                  </Form.Label>
                  <Row
                    style={{
                      backgroundColor: themeConfig.background.tertiary,
                    }}
                  >
                    <Row
                      style={{ backgroundColor: themeConfig.background.tertiary, margin: "0" }}
                      className={"my-1 ml-0 mr-0 px-5 py-4"}
                    >
                      <Col md={6}>
                        <FormGroup>
                          <FormControlLabel
                            style={{ fontSize: "14px" }}
                            defaultValue={eventType}
                            control={
                              <Radio
                                ref={rEventType}
                                checked={eventType === "PUBLIC"}
                                value="PUBLIC"
                                onChange={handleChangePublic}
                              />
                            }
                            label="Public event"
                          />
                          <span style={{ color: themeConfig.neutral.gray[1300], fontSize: "12px" }}>
                            Any user can register
                          </span>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <FormControlLabel
                            style={{ fontSize: "14px" }}
                            defaultValue={eventType}
                            control={
                              <Radio
                                ref={rEventType}
                                checked={eventType === "PRIVATE"}
                                value="PRIVATE"
                                onChange={handleChangePrivate}
                              />
                            }
                            label="Private event"
                          />
                          <span style={{ color: themeConfig.neutral.gray[1300], fontSize: "12px" }}>
                            Only selected user
                          </span>
                        </FormGroup>
                      </Col>
                    </Row>
                    {activePublic && (
                      <>
                        <Col
                          md={12}
                          className={"mx-5 mt-3"}
                          style={{
                            display: "flex",
                            marginBottom: "20px",
                          }}
                        >
                          <ButtonLink
                            onClick={() => {
                              handleCleanSelects();
                            }}
                            className="text-dark text-right w-98"
                          >
                            Advanced Search
                          </ButtonLink>
                        </Col>
                        <Col
                          md={12}
                          className={"mx-5  mt-3"}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <FormGroup className={"ml-4"}>
                            <FormControlLabel
                              control={
                                <>
                                  <SpeedIcon className={"mr-2"} />
                                </>
                              }
                              label="This event has a population limit"
                            />
                          </FormGroup>
                          <div style={{ width: "17%" }}>
                            <Form.Control
                              required
                              min={0}
                              type={"number"}
                              onKeyPress={(e) => handleValideKey(e)}
                              id="outlined-people"
                              defaultValue={`${participantsLimit}`}
                              onChange={handleChangeSelectLimitPeople}
                              disabled={!activePublic}
                            />
                          </div>
                          <div className="ml-3"> &nbsp;People </div>
                        </Col>
                        {publicGroups?.length > 0 && activePublic && (
                          <Col md={12} className="my-3">
                            <List className="w-98">
                              <TextTitleList className="font-weight-bold">
                                Groups
                              </TextTitleList>
                              {publicGroups &&
                                publicGroups.map((item, index) => {
                                  return (
                                    <Row key={index}>
                                      <Col
                                        md="4"
                                        className="d-flex align-items-center"
                                      >
                                        {index + 1}.{" "}
                                        {item.groupName
                                          ? item.groupName
                                          : item.label}
                                      </Col>
                                      <Col
                                        md="4"
                                        className="d-flex align-items-center justify-content-end"
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                      >
                                        {item?.usersCount
                                          ? item?.usersCount
                                          : item?.totalUsers}
                                      </Col>
                                      <Col
                                        md="4"
                                        className="d-flex justify-content-center"
                                      >
                                        <Tooltip title="Remove">
                                          <IconButton
                                            onClick={() =>
                                              removeGroupsAsigned(index, item)
                                            }
                                          >
                                            <RemoveCircleOutline
                                              style={{ color: themeConfig.primary.purple }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </Col>
                                    </Row>
                                  );
                                })}
                            </List>
                          </Col>
                        )}
                      </>
                    )}
                    {activePrivate && (
                      <Col md={12} className={"my-3 user-assign-section"}>
                        <ContentSelect>
                          <Form.Label
                            style={{ gridArea: "heading", fontWeight: "600" }}
                          >
                            Event users assignation (if private)
                          </Form.Label>
                          <ButtonLink
                            onClick={() => {
                              handleCleanSelects();
                            }}
                            className="text-dark text-right w-98"
                          >
                            Advanced Search
                          </ButtonLink>
                          <Select
                            className="user-select"
                            placeholder="Add guests"
                            isMulti
                            ref={rSelectedUsers}
                            options={guestsData}
                            styles={SelectStyles}
                            isDisabled={!activePrivate}
                            onChange={handleChangeSelectUsers}
                          />
                        </ContentSelect>
                      </Col>
                    )}
                    {individualGuests?.length > 0 &&
                      activePrivate &&
                      !loadingUsersInRole &&
                      !errorUsersInRole && (
                        <Col md={12} className="my-3">
                          <List className="w-98">
                            <TextTitleList className="font-weight-bold">
                              Users
                            </TextTitleList>

                            {individualGuests &&
                              individualGuests.map((item, index) =>
                                <Row key={index}>
                                  <Col
                                    md="8"
                                    className="d-flex align-items-center"
                                  >
                                    {index + 1}. {item.label}
                                  </Col>
                                  <Col
                                    md="4"
                                    className="d-flex justify-content-center"
                                  >
                                    <Tooltip title="Remove">
                                      <IconButton
                                        onClick={() =>
                                          removeUserAsigned(index, item.label)
                                        }
                                      >
                                        <RemoveCircleOutline
                                          style={{ color: themeConfig.primary.purple }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Col>
                                </Row>

                              )}
                          </List>
                        </Col>
                      )}
                    {privateGroups?.length > 0 && activePrivate && (
                      <Col md={12} className="my-3">
                        <List className="w-98">
                          <TextTitleList className="font-weight-bold">
                            Groups
                          </TextTitleList>
                          {privateGroups &&
                            privateGroups.map((item, index) => <Row key={index}>
                              <Col
                                md="4"
                                className="d-flex align-items-center"
                              >
                                {index + 1}.{" "}
                                {item.groupName
                                  ? item.groupName
                                  : item.label}
                              </Col>
                              <Col
                                md="4"
                                className="d-flex align-items-center justify-content-end"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {item?.usersCount
                                  ? item?.usersCount
                                  : item?.totalUsers}
                              </Col>
                              <Col
                                md="4"
                                className="d-flex justify-content-center"
                              >
                                <Tooltip title="Remove">
                                  <IconButton
                                    onClick={() =>
                                      removeGroupsAsigned(index, item)
                                    }
                                  >
                                    <RemoveCircleOutline
                                      style={{ color: themeConfig.primary.purple }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Col>
                            </Row>)}
                        </List>
                      </Col>
                    )}
                  </Row>
                </FormControl>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12} className={"mb-3"}>
                <Form.Label>
                  Category <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </Form.Label>{" "}
                <Select
                  className="w-98"
                  placeholder="Select an option"
                  options={categories}
                  ref={rCategoryObj}
                  styles={SelectStyles}
                  onChange={handleChangeSelectCategories}
                />
              </Col>
              <Col md={12} className={"my-3"}>
                <Form.Label>
                  Country <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </Form.Label>{" "}
                <Select
                  className="w-98"
                  placeholder="Select an option"
                  options={countries}
                  styles={SelectStyles}
                  ref={rCountryObj}
                  onChange={handleChangeSelectCountries}
                />
              </Col>
              <Col md={12} className={"my-3"}>
                <Form.Label>
                  City <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </Form.Label>{" "}
                <Select
                  className="w-98"
                  placeholder="Select an option"
                  options={cities}
                  ref={rCityObj}
                  styles={SelectStyles}
                  onChange={handleChangeSelectCities}
                />
              </Col>
              <Col md={12} className={"my-3"}>
                <Form.Label>
                  Language (language that the event will be spoken){" "}
                  <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </Form.Label>{" "}
                <Select
                  className="w-98"
                  placeholder="Select an option"
                  options={languages}
                  ref={rLanguageObj}
                  styles={SelectStyles}
                  onChange={handleChangeSelectLanguages}
                />
              </Col>
              <Col md={12} className={"my-3"}>
                <Form.Label>
                  Event date and time{" "}
                  <span style={{ color: themeConfig.primary.redLight }}>*</span>
                </Form.Label>{" "}
                <Row style={{ width: "100%" }}>
                  <Col md="6">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      showTimeSelect
                      timeIntervals={10}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      customInput={
                        <div
                          className="py-4"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: themeConfig.background.tertiary,
                            justifyContent: "center",
                          }}
                        >
                          <AccessTimeFilledIcon
                            style={{ cursor: "pointer", marginRight: "0.3em" }}
                          />{" "}
                          <span style={{ color: themeConfig.neutral.gray[1600] }}>
                            {startDate
                              ? `${moment(
                                startDate,
                                "MMMM D, yyyy h:mm aa"
                              ).format("MMMM D, yyyy h:mm a")}`
                              : "Select a date and time"}
                          </span>
                        </div>
                      }
                    />
                  </Col>
                  <Col md={6}>
                    <DatePicker
                      selected={finishDate}
                      onChange={(date) => setFinishDate(date)}
                      showTimeSelect
                      timeIntervals={10}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      customInput={
                        <div
                          className="py-4"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: themeConfig.background.tertiary,
                            justifyContent: "center",
                          }}
                        >
                          <AccessTimeFilledIcon
                            style={{ cursor: "pointer", marginRight: "0.3em" }}
                          />{" "}
                          <span style={{ color: themeConfig.neutral.gray[1600] }}>
                            {finishDate
                              ? `${moment(
                                finishDate,
                                "MMMM D, yyyy h:mm aa"
                              ).format("MMMM D, yyyy h:mm a")}`
                              : "Select a date and time"}
                          </span>
                        </div>
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <div className="w-98 my-3">
                <RecurrenceComponent
                  title={"Add recurrence for this event"}
                  cleanRecurring={handleCleanEventRecurring}
                  setShowUpdateRecurringButton={setShowUpdateRecurringButton}
                  setShowRecurring={setShowEventRecurring}
                />
              </div>
              <div className="w-98" style={{ marginLeft: "4.5em" }}>
                {listOfSurveyRecurring}
              </div>
              <Col md={12} className={"my-3"}>
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input-event-url"
                  style={{ fontSize: "18px", color: "#000" }}
                >
                  Event url
                </InputLabel>
                <Form.Control
                  required
                  className={"w-98"}
                  id="outlined-enter-url-event"
                  defaultValue={`${eventUri}`}
                  placeholder={"Paste your Event URL here"}
                  onChange={handleChangeEventUri}
                />
              </Col>
              <Col
                md={12}
                className={"my-3 user-assign-section speaker-section"}
              >
                <Form.Label style={{ gridArea: "heading", fontWeight: "500" }}>
                  Select Speakers
                </Form.Label>{" "}
                <div
                  className="text-right"
                  style={{ gridArea: "link", justifySelf: "end" }}
                >
                  <ButtonLink
                    onClick={() => {
                      setShowCreateSpeaker(true);
                    }}
                    className="text-dark"
                  >
                    create a new speaker
                  </ButtonLink>
                </div>
                <Select
                  className="user-select"
                  placeholder="Select a speaker"
                  options={speakers}
                  styles={SelectStyles}
                  value={speakersSelected}
                  isMulti
                  onChange={handleChangeSelectSpeakers}
                />
              </Col>
              {speakersSelected.length > 0 && (
                <Col md={12} className="my-3">
                  <List className="w-98">
                    <TextTitleList className="font-weight-bold">
                      Speakers
                    </TextTitleList>
                    {speakersSelected &&
                      speakersSelected.map((item, index) =>
                        <Row key={index}>
                          <Col md="8" className="d-flex align-items-center">
                            {index + 1}. {item.label}
                          </Col>
                          <Col
                            md="4"
                            className="d-flex justify-content-center"
                          >
                            <Tooltip title="Remove">
                              <IconButton
                                onClick={() =>
                                  removeSpeaker(index, item.label)
                                }
                              >
                                <RemoveCircleOutline
                                  style={{ color: themeConfig.text.primary }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Col>
                        </Row>
                      )}
                  </List>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      )}
      {!loadingEventById && !errorEventById && (
        <Row>
          <Row>
            <Col
              md={12}
              className={"mx-5 my-3"}
              style={{
                display: "flex",
                maxWidth: "91%",
                justifyContent: "flex-end",
              }}
            >
              <ButtonCancel onClick={handleGoToBackPage}>Cancel</ButtonCancel>
              {action === "add" ? (
                <ButtonCreateEvent onClick={addEvent}>
                  Create Event
                </ButtonCreateEvent>
              ) : (
                <ButtonCreateEvent onClick={editEvent}>
                  Update Event
                </ButtonCreateEvent>
              )}
            </Col>
          </Row>
        </Row>
      )}
      {modalAdvanceOptions}
      {modalEventRecurring}
      {showDeleteRecurringModal()}
      {showCreateSpeaker && (
        <PortalModal>
          <ContentPortal>
            <HeaderContent>
              <div></div>
              <CloseIcon onClick={() => setShowCreateSpeaker(false)} />
            </HeaderContent>
            <InfoContent>
              <CreateSpeakerContainer
                setShowCreateSpeaker={setShowCreateSpeaker}
                cancelFn={() => setShowCreateSpeaker(false)}
              />
            </InfoContent>
          </ContentPortal>
        </PortalModal>
      )}
    </ContentCreateEvent>
  );
};

export default ManageEvent;

ManageEvent.propTypes = {
  action: PropTypes.string,
  idEvent: PropTypes.string,
  usersAdvanceSearch: PropTypes.array,
  detailEvent: PropTypes.object,
  categories: PropTypes.array,
  countries: PropTypes.array,
  cities: PropTypes.array,
  setCities: PropTypes.func,
  languages: PropTypes.array,
  speakers: PropTypes.array,
  guestsData: PropTypes.array,
  individualGuests: PropTypes.array,
  allCountries: PropTypes.array,
  allCities: PropTypes.array,
  setAllCities: PropTypes.func,
  allLobs: PropTypes.array,
  allRolesByLevel: PropTypes.array,
  selectedCountry: PropTypes.array,
  selectedCity: PropTypes.array,
  selectedRole: PropTypes.array,
  selectedLob: PropTypes.array,
  showCreateSpeaker: PropTypes.bool,
  showAdvanceOption: PropTypes.bool,
  loadingEventById: PropTypes.bool,
  errorEventById: PropTypes.bool,
  loadingRoleByLevel: PropTypes.bool,
  errorRoleByLevel: PropTypes.bool,
  loadingUsersInRole: PropTypes.bool,
  errorUsersInRole: PropTypes.bool,
  setIndividualGuests: PropTypes.func,
  setShowCreateSpeaker: PropTypes.func,
  setSelectedCountry: PropTypes.func,
  setSelectedCity: PropTypes.func,
  handleCleanSelects: PropTypes.func,
  handleGoToBackPage: PropTypes.func,
  handleCities: PropTypes.func,
  handleCitiesByCountry: PropTypes.func,
  handleUsersByIds: PropTypes.func,
  handleChangeSelectRole: PropTypes.func,
  handleChangeSelectLob: PropTypes.func,
  handleValideKey: PropTypes.func,
  handleCloseAdvanceSearch: PropTypes.func,
  handleCleanEventRecurring: PropTypes.func,
  showUpdateRecurringButton: PropTypes.bool,
  setShowUpdateRecurringButton: PropTypes.func,
  setShowEventRecurring: PropTypes.func,
  showEventRecurring: PropTypes.bool,
  handleCloseEventRecurring: PropTypes.func,
  repeatEvery: PropTypes.number,
  setRepeatEvery: PropTypes.func,
  dateOptions: PropTypes.array,
  periodRecurring: PropTypes.string,
  setPeriodRecurring: PropTypes.func,
  dataButtonDays: PropTypes.array,
  dataButtonDaysValue: PropTypes.array,
  optionForMonth: PropTypes.array,
  optionForMonthSelected: PropTypes.object,
  setOptionForMonthSelected: PropTypes.func,
  dataEndsDate: PropTypes.array,
  activeEndsRecurring: PropTypes.string,
  setActiveEndsRecurring: PropTypes.func,
  onEndRecurring: PropTypes.string,
  setOnEndRecurring: PropTypes.func,
  handleCreateRecurringEvent: PropTypes.func,
  handleUpdateRecurringEvent: PropTypes.func,
  recurringEvents: PropTypes.array,
  setRecurringEvents: PropTypes.func,
  handleEditRecurring: PropTypes.func,
  openDeleteRecurringModal: PropTypes.object,
  setOpenDeleteRecurringModal: PropTypes.func,
  handleDeleteRecurring: PropTypes.func,
  recurrence: PropTypes.object,
  handleChangeComoNoComo: PropTypes.func,
}